import { applyMiddleware, createStore } from "redux"
import createSagaMiddleware from "redux-saga"
import logger from "redux-logger"

import rootReducer from "reducers"
import rootSaga from "sagas"

const sagaMiddleware = createSagaMiddleware()

const store = createStore(
  rootReducer,
  applyMiddleware(
    ...(process.env.NODE_ENV === "development"
      ? [sagaMiddleware, logger]
      : [sagaMiddleware])
  )
)
sagaMiddleware.run(rootSaga)

export default store
